import { render, staticRenderFns } from "./FarmerSelect.vue?vue&type=template&id=00ae383e"
import script from "./FarmerSelect.vue?vue&type=script&lang=js"
export * from "./FarmerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports